/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", () => {
  try {
    const search = document.querySelector("#search-custom-input");
	const viewMore = document.querySelector("#results-redirect-btn");
    const results = document.querySelector(".results");
    const resultsInner = document.querySelector(".results-inner");
	const savedList = results.innerHTML;
	console.log("saved list", savedList);
	const resultsBg = document.querySelector(".results-bg-1");
	const predictiveSearch = document.querySelector("#search-route-new");
    var predictiveText = "";
    search.addEventListener("focusin", (e) => {
      console.log("search focused....");
      resultsBg.style.opacity = "1";
            resultsBg.style.width = "100%";
                  resultsBg.style.height = "100%";
       results.style.transform = "scaleY(1)";
    });
    search.addEventListener("focusout", (e) => {
//       if(predictiveText.length === 0) {
//       console.log("search not focused....");
//             resultsBg.style.opacity = "0";
//       results.style.transform = "scaleY(0)";
//                   resultsBg.style.width = "0%";
//                   resultsBg.style.height = "0%";
//       }
    });
resultsBg.addEventListener('click', event => {
	       resultsBg.style.opacity = "0";
      results.style.transform = "scaleY(0)";
                  resultsBg.style.width = "0%";
                  resultsBg.style.height = "0%";
});
search.addEventListener('input', (event) => {
  predictiveText = event.target.value;
  if(predictiveText.length === 0) {
   resultsInner.innerHTML = savedList;
    viewMore.style.display = "none";
  } else {
//      viewMore.style.display = "block";
	 _doPredictiveSearch(event.target.value, resultsInner, viewMore);
    
  }
});
  } catch (e) {
    console.log("search error", e);
  }

  try {
                const showHideText = document.querySelectorAll("[load-more]");
                showHideText.forEach(element => {
                    let show = false;
                    const showMoreBtn = element.querySelector(".hidden-view-more");
                    const showMoreTitle = element.querySelector("#show-more-title");
                    const textInner = element.querySelector(".text-inner-hide-show");
                    const icon = element.querySelector(".show-more-icon");
                    const activeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" /></svg>';
                    const inactiveIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <path d="M0 10h24v4h-24z" /></svg>'
                    const height = textInner.clientHeight + 130 + "px";
                    console.log("icon", icon);
                    showMoreBtn.addEventListener("click", (event) => {
                        show = !show;
//                         element.style.height = show ? auto : "180px"
                        element.style.maxHeight = show ? height : "200px"
                        element.style.overflow = show ? "initial" : "hidden";
                        showMoreTitle.innerHTML = show ? "Vezi mai putin" : "Vezi mai mult";
                        icon.innerHTML = show ? inactiveIcon : activeIcon;
                    });
                })

        } catch (er) {
            console.log("Err show more");
        }


});

 async function _doPredictiveSearch(term, result, showMoreBtn) {
      const response = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${term}&resources[limit]=10&resources[type]=${window.themeVariables.settings.searchMode}&resources[options[unavailable_products]]=${window.themeVariables.settings.searchUnavailableProducts}&resources[options[fields]]=title,body,product_type,variants.title,vendor&section_id=predictive-search`, {
//         signal: this.abortController.signal
      });
	  const responseData = await response.text();
            result.innerHTML = responseData;
   if(responseData.includes("reset-search")) {
      showMoreBtn.style.display = "none";
      let center = document.querySelector("#shopify-section-predictive-search");
     	console.log("center1", center);
     	center.style.justifyContent = "center";
     	center.style.alignItems = "center";
     	showMoreBtn.href= "#";
      } else {
        
            showMoreBtn.style.display = "block";
         let center = document.querySelector("#shopify-section-predictive-search");
             	console.log("center2", center);
     	center.style.justifyContent = "stretch";
     	center.style.alignItems = "stretch";
        showMoreBtn.href= "/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&q=" + term;
   	  console.log("response data", responseData);
 	}
 }
